/**
 * Entdecken-Teaser auf „Heute" (13.07.) — Sichtbarkeit für die Welt-Scan-
 * Vorschläge. Der Scan läuft nachts über ~50 ETFs außerhalb der Watchlist;
 * die Vorschlags-Inbox liegt in der Watchlist (leicht zu übersehen). Diese
 * schlanke Zeile zeigt IMMER, dass der Scan aktiv ist, und führt hin — auch
 * wenn gerade nichts aufdreht (in Gier-/Neutral-Phasen normal).
 */

import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useDataState } from '@/hooks/use-data-state';
import { useDemoMode } from '@/contexts/DemoModeContext';
import { fetchDiscoverySuggestions } from '@/lib/discovery-read';

export function EntdeckenTeaser() {
  const navigate = useNavigate();
  const { linkTo } = useDemoMode();
  const suggestions = useDataState({
    queryKey: ['discovery-suggestions'],
    queryFn: () => fetchDiscoverySuggestions(),
    ttlSeconds: 15 * 60,
    isEmpty: () => false, // leere Liste ist ein gültiges Ergebnis, kein „empty"
  });

  if (suggestions.state.status === 'loading') return null;
  const n = suggestions.state.data?.length ?? 0;

  return (
    <button
      type="button"
      onClick={() => navigate(linkTo('/watchlist'))}
      className="w-full flex items-center gap-2 rounded-md border border-zinc-800/80 bg-zinc-900/30 px-3 py-2 text-left text-xs hover:bg-zinc-800/40 transition-colors"
    >
      <Compass className="size-4 shrink-0 text-amber-300" />
      {n > 0 ? (
        <span className="text-zinc-200">
          <span className="font-semibold text-amber-200">{n} entdeckt</span> — neue Kandidaten aus
          dem Welt-Universum, die zur Lage passen.
        </span>
      ) : (
        <span className="text-zinc-400">
          Welt-Scan aktiv — aktuell dreht kein Wert von unten auf (in ruhigen Phasen normal).
        </span>
      )}
      <span className="ml-auto shrink-0 text-[10px] text-zinc-500">Watchlist →</span>
    </button>
  );
}
